import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { confirmRefrenceCondition } from "../../network/cipAPI";

import DupontButton from "../../components/DupontButton";
import DupontRadio from "../../components/DupontRadio";
import InputBox from "../../components/InputBox";
import createNotification, {
  SUCCESS_NOTIFICATION,
  ERROR_NOTIFICATION,
} from "../../components/Notifications";
import { OverlayLoader } from "../../components/PageLoading";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";

import { UpdateSetWithKey } from "../../utils/Utils";

import { REFERENCE_CONDITION_OPTIONS } from "./columns.config";

import "./index.scss";

const ReferenceCondition = ({
  fileId,
  mappedReference,
  isEdit,
  setisReferenceEnabled,
  selectedColumnRadioColumn,
  selectedTrain,
}) => {
  const { t } = useTranslation();

  const referenceColumns = REFERENCE_CONDITION_OPTIONS(
    t,
    selectedColumnRadioColumn
  );

  const { flow, pressure, feed_quality, permeate_quality, temperature } =
    useSelector((state) => state);
  const [defaultSettingUnit, setDefaultSettingUnit] = useState({
    flow,
    pressure,
    feed_quality,
    permeate_quality,
    temperature,
  });
  const [selectedRadioColumn, setSelectedRadioColumn] = useState({
    ["column19"]: "pressure_drop",
  });
  const [selectedReference, setSelectedReference] = useState([]);
  const [changedSelectedReference, setChangedSelectedReference] = useState([]);
  const [showOverLayLoader, setShowOverLayLoader] = useState(false);

  useEffect(() => {
    if (mappedReference) {
      for (const key in mappedReference) {
        const val = mappedReference[key];
        if (typeof val === "number") {
          mappedReference[key] =
            val === 0 ? val.toString() : Number(val.toFixed(2));
        }
      }
      setSelectedReference(mappedReference);
      if (isEdit) {
        setisReferenceEnabled(false);
      }
    } else {
      setSelectedReference({});
    }
  }, [mappedReference]);

  useEffect(() => {
    if (!fileId) {
      setSelectedReference([]);
      setChangedSelectedReference([]);
    }
  }, [fileId]);

  const getKey = (column) => {
    const key =
      column.options === undefined
        ? column.key
        : selectedRadioColumn[column.key];
    return key;
  };
  // const handleOptionChange = (event) => {
  //   setisReferenceEnabled(false);
  //   const { name, value } = event.target;
  //   setSelectedRadioColumn({ ...selectedRadioColumn, [name]: value });
  // };
  // const getchecked = (column, key) => {
  //   return selectedRadioColumn[column] === key;
  // };

  const onInputValChange = (value, key) => {
    setisReferenceEnabled(false);
    setSelectedReference({ ...selectedReference, [key]: value });
    setChangedSelectedReference((prevSet) =>
      UpdateSetWithKey(prevSet, key, value)
    );
  };
  const getConfirmButtonState = () => {
    const {
      feed_flowrate,
      concentrate_flowrate,
      permeate_flowrate,
      feed_pressure,
      permeate_pressure,
      feed_temp,
      permeate_quality,
      feed_quality,
      concentrate_pressure,
      pressure_drop,
    } = selectedReference;

    const hasAllInputs =
      (feed_flowrate || concentrate_flowrate) &&
      permeate_flowrate &&
      feed_pressure &&
      permeate_pressure &&
      feed_temp &&
      permeate_quality &&
      feed_quality &&
      (concentrate_pressure || pressure_drop);

    if (
      (!isEdit && hasAllInputs) ||
      (isEdit &&
        hasAllInputs &&
        Object.keys(changedSelectedReference).length > 0)
    ) {
      return false;
    } else return true;
  };

  const confirmRefrenceConditions = async () => {
    setShowOverLayLoader(true);
    try {
      let payload = null;
      if (mappedReference) payload = changedSelectedReference;
      else payload = selectedReference;
      const response = await confirmRefrenceCondition(
        fileId,
        payload,
        selectedTrain
      );
      if (response) {
        setChangedSelectedReference([]);
        createNotification(
          SUCCESS_NOTIFICATION,
          t("analyseData.referenceAdded"),
          ""
        );
      } else {
        createNotification(ERROR_NOTIFICATION, response.detail.error, "");
      }
    } catch (err) {
      console.log("confirmRefrenceCondition:", err);
    } finally {
      setShowOverLayLoader(false);
    }
  };

  return (
    <div className="lightGrayBorder padding10 position-relative">
      {showOverLayLoader && <OverlayLoader customHeight={"300px"} />}
      <div className="box-title text-align-left">
        {t("analyseData.referenceCondition")}
      </div>
      <div className="flex-ai-center container-padding position-relative">
        <div className="grid-container-column">
          {Object.keys(referenceColumns).map((referenceColumn, index) => (
            <div className="grid-item-column ">
              <div className="width-250">
                {/* {referenceColumns[referenceColumn].options ? (
                  <div>
                    {Object.values(
                      referenceColumns[referenceColumn].options
                    ).map((option) => (
                      <div
                        key={option.key}
                        onChange={handleOptionChange}
                        className="checkbox-container"
                      >
                        <div className="marginBtm5">
                          <DupontRadio
                            text={option.name.replace(
                              "<unit>",
                              `(${defaultSettingUnit[option.unit]})`
                            )}
                            fontsize={"font-14"}
                            checked={getchecked(referenceColumn, option.key)}
                            value={option.key}
                            name={referenceColumn}
                            isRequired
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : ( */}
                <>
                  <label>
                    {referenceColumns[referenceColumn].name !== undefined &&
                      referenceColumns[referenceColumn].name.replace(
                        "<unit>",
                        `(${
                          defaultSettingUnit[
                            referenceColumns[referenceColumn].unit
                          ]
                        })`
                      )}
                  </label>
                  <span style={{ color: "red" }}>*</span>
                </>
                {/* )} */}
              </div>
              <div className="width-dropdown">
                <InputBox
                  name="reference"
                  key={referenceColumns[referenceColumn].key}
                  value={
                    selectedReference[
                      getKey(referenceColumns[referenceColumn])
                    ] || ""
                  }
                  onChange={(value) =>
                    onInputValChange(
                      value,
                      getKey(referenceColumns[referenceColumn])
                    )
                  }
                  validator={TextFieldValidator.NUMBER_TWO_DECIMAL}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="reference-button ">
          <DupontButton
            disabled={getConfirmButtonState()}
            customClass="margin-left-10 "
            onClick={confirmRefrenceConditions}
          >
            {t("analyseData.confirmReferenceSelection")}
          </DupontButton>
        </div>
      </div>
    </div>
  );
};
export default ReferenceCondition;
